import PageLayout from '../../components/feature/PageLayout';
import PageHero from '../../components/feature/PageHero';
import SEO from '../../components/feature/SEO';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://tallermecanicokevin.com';

const sections = [
  {
    title: 'Datos del Titular',
    icon: 'ri-building-line',
    content: [
      { label: 'Denominación', value: 'Taller Mecánico Kevin Alberto' },
      { label: 'Titular', value: 'Kevin Alberto' },
      { label: 'Actividad', value: 'Taller de reparación de vehículos a motor' },
      { label: 'Dirección', value: 'C. Guadalimar, 7, 29400 Ronda, Málaga, España' },
      { label: 'Teléfono', value: '+34 666 36 59 22' },
      { label: 'Email', value: 'tallerkevinalberto@gmail.com' },
    ],
  },
];

const legalBlocks = [
  {
    id: 'objeto',
    icon: 'ri-file-list-3-line',
    title: '1. Objeto y Ámbito de Aplicación',
    body: `El presente Aviso Legal regula el acceso y uso del sitio web ${siteUrl} (en adelante, "el Sitio Web"), titularidad de Taller Mecánico Kevin Alberto, con domicilio en C. Guadalimar, 7, Ronda, Málaga.\n\nEl acceso y utilización del Sitio Web atribuye la condición de usuario e implica la plena aceptación de todas las disposiciones incluidas en este Aviso Legal. Si el usuario no está de acuerdo con alguna de las condiciones aquí establecidas, deberá abstenerse de acceder y/o utilizar los servicios y contenidos disponibles en el Sitio Web.`,
  },
  {
    id: 'propiedad-intelectual',
    icon: 'ri-copyright-line',
    title: '2. Propiedad Intelectual e Industrial',
    body: `Todos los contenidos del Sitio Web, incluyendo, sin carácter limitativo, textos, fotografías, gráficos, imágenes, iconos, logotipos, marcas, nombres comerciales, diseño gráfico, código fuente y demás elementos, son propiedad de Taller Mecánico Kevin Alberto o de sus legítimos titulares, quedando protegidos por los derechos de propiedad intelectual e industrial.\n\nQueda expresamente prohibida la reproducción, distribución, transformación o comunicación pública, total o parcial, de los contenidos del Sitio Web sin la autorización expresa y por escrito de Taller Mecánico Kevin Alberto.`,
  },
  {
    id: 'responsabilidad',
    icon: 'ri-shield-check-line',
    title: '3. Exclusión de Responsabilidad',
    body: `Taller Mecánico Kevin Alberto no se hace responsable de los daños o perjuicios de cualquier naturaleza que pudieran derivarse del acceso o uso del Sitio Web, ni de la información contenida en el mismo.\n\nAsimismo, Taller Mecánico Kevin Alberto no garantiza la ausencia de virus u otros elementos lesivos que pudieran causar daños o alteraciones en el sistema informático, documentos electrónicos o ficheros del usuario.`,
  },
  {
    id: 'privacidad',
    icon: 'ri-lock-password-line',
    title: '4. Política de Privacidad y Protección de Datos',
    body: `En cumplimiento del Reglamento General de Protección de Datos (RGPD) UE 2016/679 y de la Ley Orgánica 3/2018 (LOPDGDD), los datos personales facilitados voluntariamente a través de los formularios de contacto del Sitio Web serán tratados por Taller Mecánico Kevin Alberto con la finalidad de gestionar las consultas, citas y presupuestos solicitados.\n\nEl usuario podrá ejercer sus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad dirigiéndose a: tallerkevinalberto@gmail.com. Los datos no serán cedidos a terceros salvo obligación legal.\n\nLos datos serán conservados durante el tiempo necesario para atender la solicitud y el plazo legal de conservación correspondiente.`,
  },
  {
    id: 'cookies',
    icon: 'ri-cookie-line',
    title: '5. Política de Cookies',
    body: `El Sitio Web puede utilizar cookies técnicas propias necesarias para su correcto funcionamiento. Estas cookies no almacenan información de carácter personal ni se utilizan con fines publicitarios.\n\nAl continuar navegando en el Sitio Web, el usuario acepta el uso de las cookies técnicas descritas. El usuario puede configurar su navegador para rechazar la instalación de cookies, aunque esto podría afectar al correcto funcionamiento del Sitio Web.`,
  },
  {
    id: 'enlaces',
    icon: 'ri-links-line',
    title: '6. Enlaces a Terceros',
    body: `El Sitio Web puede contener enlaces a sitios web de terceros. Taller Mecánico Kevin Alberto no tiene control sobre dichos sitios web ni se hace responsable de su contenido o de las políticas de privacidad de los mismos. La inclusión de estos enlaces no implica ningún tipo de asociación o respaldo.`,
  },
  {
    id: 'legislacion',
    icon: 'ri-scales-3-line',
    title: '7. Legislación Aplicable y Jurisdicción',
    body: `El presente Aviso Legal se rige por la legislación española vigente. Para la resolución de cualquier controversia derivada del acceso o uso del Sitio Web, el usuario y Taller Mecánico Kevin Alberto se someten, con renuncia expresa a cualquier otro fuero, a los Juzgados y Tribunales de Ronda (Málaga), salvo que la normativa aplicable establezca otro fuero imperativo.`,
  },
  {
    id: 'modificaciones',
    icon: 'ri-edit-box-line',
    title: '8. Modificaciones',
    body: `Taller Mecánico Kevin Alberto se reserva el derecho a modificar, en cualquier momento y sin previo aviso, el contenido del Sitio Web y el presente Aviso Legal. Se recomienda al usuario revisar periódicamente las condiciones de uso.\n\nÚltima actualización: marzo de 2026.`,
  },
];

const AvisoLegalPage = () => (
  <PageLayout showWhatsApp={false}>
    <SEO
      title="Aviso Legal | Taller Mecánico Kevin Alberto Ronda Málaga"
      description="Aviso legal, política de privacidad y condiciones de uso del sitio web de Taller Mecánico Kevin Alberto, taller de reparación de vehículos en Ronda, Málaga."
      keywords="aviso legal taller mecánico Ronda, política privacidad taller Ronda, condiciones uso taller Kevin Alberto"
      canonical="/aviso-legal"
    />
    <PageHero
      tag="Información legal"
      title="Aviso"
      titleAccent="Legal"
      subtitle="Condiciones de uso, privacidad y términos legales del sitio web."
      breadcrumb="Aviso Legal"
      bgImage="https://public.readdy.ai/ai/img_res/d6918d37fc3cacb768ded22023b006dc.jpg"
    />

    <section className="bg-white py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-6 md:px-10">

        {/* Datos del titular */}
        {sections.map((sec) => (
          <div key={sec.title} className="mb-12 bg-zinc-50 border border-zinc-100 rounded-lg p-6 md:p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-9 h-9 flex items-center justify-center bg-yellow-400 rounded-md flex-shrink-0">
                <i className={`${sec.icon} text-black text-base`} />
              </div>
              <h2 className="text-lg font-bold text-zinc-900 uppercase tracking-wide">{sec.title}</h2>
            </div>
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {sec.content.map((item) => (
                <div key={item.label}>
                  <dt className="text-[10px] font-bold uppercase tracking-widest text-zinc-400 mb-1">{item.label}</dt>
                  <dd className="text-sm text-zinc-700 font-medium">{item.value}</dd>
                </div>
              ))}
            </dl>
          </div>
        ))}

        {/* Bloques legales */}
        <div className="space-y-8">
          {legalBlocks.map((block) => (
            <div key={block.id} id={block.id} className="scroll-mt-24">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className={`${block.icon} text-yellow-500 text-lg`} />
                </div>
                <h4 className="text-base font-bold text-zinc-900">
                  <a href={`#${block.id}`} className="hover:text-yellow-600 transition-colors">{block.title}</a>
                </h4>
              </div>
              <div className="pl-11 space-y-3">
                {block.body.split('\n\n').map((para, i) => (
                  <p key={i} className="text-sm text-zinc-600 leading-relaxed font-light">{para}</p>
                ))}
              </div>
              <div className="mt-6 ml-11 h-px bg-zinc-100" />
            </div>
          ))}
        </div>

        {/* Footer aviso */}
        <div className="mt-16 bg-zinc-900 text-white rounded-lg p-6 md:p-8 flex flex-col sm:flex-row items-center gap-6 justify-between">
          <div>
            <p className="text-sm font-semibold text-white mb-1">¿Tienes alguna pregunta legal?</p>
            <p className="text-xs text-zinc-400 font-light">Contáctanos directamente y te atendemos encantados.</p>
          </div>
          <a
            href="mailto:tallerkevinalberto@gmail.com"
            className="inline-flex items-center gap-2 bg-yellow-400 text-black text-xs font-bold uppercase tracking-widest px-5 py-3 hover:bg-yellow-300 transition-all duration-300 whitespace-nowrap cursor-pointer rounded-md flex-shrink-0"
          >
            <i className="ri-mail-line" />
            Enviar email
          </a>
        </div>

      </div>
    </section>
  </PageLayout>
);

export default AvisoLegalPage;
